
export default {
name: 'commission',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/commission/script.js